import axios from "../axiosInstance"

export const getDocket = async () => {
  try {
    const res = await axios.get(`/dockets`)
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to fetch docket")
    }
    return data
  } catch (error) {
    console.error("Error fetching docket:", error)
    throw error
  }
}

export const addToDocket = async (dealId: number) => {
  try {
    const res = await axios.post(`/dockets`, { dealId })
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to add to docket")
    }
    return { docketEntry: data.docketEntry, alreadyOnDocket: data.alreadyOnDocket }
  } catch (error) {
    console.error("Error adding to docket:", error)
    throw error
  }
}

export const checkDealOnDocket = async (dealId: number) => {
  try {
    const res = await axios.get(`/dockets/check/${dealId}`)
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to check docket")
    }
    return data.onDocket as boolean
  } catch (error) {
    console.error("Error checking docket:", error)
    throw error
  }
}

export const removeFromDocket = async (id: number) => {
  try {
    const res = await axios.delete(`/dockets/${id}`)
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to remove from docket")
    }
    return data
  } catch (error) {
    console.error("Error removing from docket:", error)
    throw error
  }
}
